import * as React from "react"

import { get } from 'lodash'
import { TableBody, TableCell, TableRow, cn } from 'twyne-new.ui';

const Body = ({ data, columns, rowClassName, keyField, rowWrapper, fixedFistColumnOnScroll = false }) => {
  if (!data || data.length === 0) {
    return null
  }

  const RowWrapper = rowWrapper || TableRow
  return <TableBody>
    {data.map((row, rowIndex) => {
      const rowKey = keyField ? row[keyField] : rowIndex
      return <RowWrapper
        className={cn(rowClassName && rowClassName(row), rowIndex % 2 && 'twy-bg-base')}
        key={rowKey}
        row={{ ...row, index: rowIndex }}
      >
        {columns.map((column, colIndex) => <DefaultTableCell
          key={colIndex}
          className={column.className}
          fixColumn={fixedFistColumnOnScroll && colIndex === 0}
          rowIndex={rowIndex}
        >
          {column.formatter ? column.formatter(get(row, column.dataField), row, rowIndex) : get(row, column.dataField)}
        </DefaultTableCell>)}
      </RowWrapper>
    })}
  </TableBody>
}

const DefaultTableCell = ({ children, className, fixColumn, rowIndex }) => <TableCell
  className={cn(
    'truncate max-w-80',
    className,
    fixColumn && 'sticky left-0 z-20',
    rowIndex % 2 ? 'twy-bg-base' : 'twy-bg-base-accent',
  )}>
  {children}
</TableCell>

export default React.memo(Body)
